import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import closeImg from 'Assets/x-icon-gray.svg'

import style from './style.css'

export default function SlowDeductModal (props) {
  const okRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (okRef.current) {
        okRef.current.focus();
      }
    }, 0);
  }, []);
  
  return (
    <div>
      <Modal show={true} className={classnames(style.modalContainer)} data-test-id="slowDownModal">
        <div className={style.contentWrapper}>
          <Modal.Header className={classnames('modal-header', style.headerContainer)}>
            <Modal.Title className={style.modalTitle}>
              <span className={style.modalTitleText}>Slow down!</span>
              <button
                onClick={props.onClick}
                className={classnames(style.hideModal)}
                data-test-id="slowDownHideModalBtn"
              >
                <img
                  src={closeImg}
                  alt="Close message"
                />
              </button>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className={style.content}>
              Note that the potential points you can earn for answering questions has been reduced
              because you are guessing too quickly. If you slow down, this penalty will be removed.
            </p>
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <button
              aria-label="Close message"
              className={classnames('btn-cdl-main', style.modalClose)}
              onClick={props.onClick}
              data-test-id="slowDownModalOkBtn"
              autoFocus
              ref={okRef}
            >
              OK
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  )
}

SlowDeductModal.propTypes = {
  onClick: PropTypes.func.isRequired
}
